import { cpAuditItemStatusEnumLocs, spAuditItemStatusEnumLocs } from './audit-item-status.locs';
import { cpAuthPackageStateEnumLocs, spAuthPackageStateEnumLocs } from './auth-package-state.locs';
import { cpBadgeTypeEnumLocs, spBadgeTypeEnumLocs } from './badge-type.locs';
import { cpBcatGrantTypeEnumLocs, spBcatGrantTypeEnumLocs } from './bcat-grant-type.locs';
import { cpBcatTypeEnumLocs, spBcatTypeEnumLocs } from './benefit-catalog-type.locs';
import { cpBenefitStatusEnumLocs, spBenefitStatusEnumLocs } from './benefit-status.locs';
import {
	cpCcatExtensionTypeEnumLocs,
	spCcatExtensionTypeEnumLocs,
} from './ccat-extension-type.locs';

import { cpCateidTypeEnumLocs, spCateidTypeEnumLocs } from './cateid-type.locs';

import {
	cpWuserCandRestrictTypeEnumLocs,
	spWuserCandRestrictTypeEnumLocs,
} from './cand-restrict-type.locs';
import {
	cpCandidateAuditHistoryStatusEnumLocs,
	spCandidateAuditHistoryStatusEnumLocs,
} from './candidate-audit-history-status.locs';
import {
	cpCreqAuditCandidateStatusEnumLocs,
	spCreqAuditCandidateStatusEnumLocs,
} from './candidate-audit-status.locs';
import { cpCcatPathTypeEnumLocs, spCcatPathTypeEnumLocs } from './ccat-path-type.locs';
import { spCEVoucherBatchDetailStatusEnumLocs } from './ce-voucher-batch-detail-status.locs';
import {
	cpCertCatalogStatusEnumLocs,
	spCertCatalogStatusEnumLocs,
} from './cert-catalog-status.locs';
import { cpCertStatusEnumLocs, spCertStatusEnumLocs } from './cert-status.locs';
import { spCfcRuleEnumLocs } from './cfc-rule.locs';
import { cpChTypeEnumLocs, spChTypeEnumLocs } from './ch-type.locs';
import { cpCprStateEnumLocs, spCprStateEnumLocs } from './cpr-state.locs';
import { cpCprTypeEnumLocs, spCprTypeEnumLocs } from './cpr-type.locs';
import { cpCraActionEnumLocs, spCraActionEnumLocs } from './cra-action.locs';
import { spCraiActionEnumLocs } from './crai-action.locs';
import { cpCrcatTypeEnumLocs, spCrcatTypeEnumLocs } from './crcat-type.locs';
import { cpCReqReviewStateLocs, spCReqReviewStateLocs } from './creq-review-state.locs';
import { cpCreqStatusEnumLocs, spCreqStatusEnumLocs } from './creq-status.locs';
import {
	cpETransactionItemCatTypeEnumLocs,
	spETransactionItemCatTypeEnumLocs,
} from './e-transaction-item-cat-type.locs';
import {
	cpETransactionStateEnumLocs,
	spETransactionStateEnumLocs,
} from './e-transaction-state.locs';
import {
	cpEligibleExamActionTypeEnumLocs,
	spEligibleExamActionTypeEnumLocs,
} from './eligible-exam-action-type.locs';
import { cpEmcatTypeEnumLocs, spEmcatTypeEnumLocs } from './emcat-type.locs';
import { cpEmrStateEnumLocs, spEmrStateEnumLocs } from './emr-state.locs';
import { cpExauthStateEnumLocs, spExauthStateEnumLocs } from './ex-auth-state.locs';
import { cpExamGradeLabelEnumLocs, spExamGradeLabelEnumLocs } from './exam-grade-label.locs';
import { cpExamStateEnumLocs, spExamStateEnumLocs } from './exam-state.locs';
import {
	cpExamViolationTypeEnumLocs,
	spExamViolationTypeEnumLocs,
} from './exam-violation-type.locs';
import { cpExapReviewStateEnumLocs, spExapReviewStateEnumLocs } from './exap-review-state.locs';
import { cpFcatQueueTypeEnumLocs, spFcatQueueTypeEnumLocs } from './fcat-queue-type.locs';
import {
	cpFulfillmentStatusEnumLocs,
	spFulfillmentStatusEnumLocs,
} from './fulfillment-status.locs';

export const enumLocs = {
	...cpCertStatusEnumLocs,
	...spCertStatusEnumLocs,
	...cpCertCatalogStatusEnumLocs,
	...spCertCatalogStatusEnumLocs,
	...cpBenefitStatusEnumLocs,
	...spBenefitStatusEnumLocs,
	...cpExamGradeLabelEnumLocs,
	...spExamGradeLabelEnumLocs,
	...cpExamStateEnumLocs,
	...spExamStateEnumLocs,
	...spCfcRuleEnumLocs,
	...cpCcatExtensionTypeEnumLocs,
	...spCcatExtensionTypeEnumLocs,
	...cpCcatPathTypeEnumLocs,
	...spCcatPathTypeEnumLocs,
	...cpBadgeTypeEnumLocs,
	...spBadgeTypeEnumLocs,
	...cpBcatTypeEnumLocs,
	...spBcatTypeEnumLocs,
	...cpBcatGrantTypeEnumLocs,
	...spBcatGrantTypeEnumLocs,
	...cpFcatQueueTypeEnumLocs,
	...spFcatQueueTypeEnumLocs,
	...cpEligibleExamActionTypeEnumLocs,
	...spEligibleExamActionTypeEnumLocs,
	...cpCateidTypeEnumLocs,
	...spCateidTypeEnumLocs,
	...cpFulfillmentStatusEnumLocs,
	...spFulfillmentStatusEnumLocs,
	...cpCReqReviewStateLocs,
	...spCReqReviewStateLocs,
	...cpCrcatTypeEnumLocs,
	...spCrcatTypeEnumLocs,
	...cpCreqStatusEnumLocs,
	...spCreqStatusEnumLocs,
	...cpCReqReviewStateLocs,
	...spCReqReviewStateLocs,
	...cpCprTypeEnumLocs,
	...spCprTypeEnumLocs,
	...cpCprStateEnumLocs,
	...spCprStateEnumLocs,
	...cpChTypeEnumLocs,
	...spChTypeEnumLocs,
	...cpExauthStateEnumLocs,
	...spExauthStateEnumLocs,
	...cpWuserCandRestrictTypeEnumLocs,
	...spWuserCandRestrictTypeEnumLocs,
	...cpETransactionStateEnumLocs,
	...spETransactionStateEnumLocs,
	...cpETransactionItemCatTypeEnumLocs,
	...spETransactionItemCatTypeEnumLocs,
	...spCfcRuleEnumLocs,
	...cpExamViolationTypeEnumLocs,
	...spExamViolationTypeEnumLocs,
	...cpExapReviewStateEnumLocs,
	...spExapReviewStateEnumLocs,
	...cpAuthPackageStateEnumLocs,
	...spAuthPackageStateEnumLocs,
	...cpCraActionEnumLocs,
	...spCraActionEnumLocs,
	...spCraiActionEnumLocs,
	...cpEmrStateEnumLocs,
	...spEmrStateEnumLocs,
	...cpEmcatTypeEnumLocs,
	...spEmcatTypeEnumLocs,
	...cpETransactionStateEnumLocs,
	...spETransactionStateEnumLocs,
	...cpETransactionItemCatTypeEnumLocs,
	...spETransactionItemCatTypeEnumLocs,
	...cpAuditItemStatusEnumLocs,
	...spAuditItemStatusEnumLocs,
	...cpCreqAuditCandidateStatusEnumLocs,
	...spCreqAuditCandidateStatusEnumLocs,
	...spCandidateAuditHistoryStatusEnumLocs,
	...cpCandidateAuditHistoryStatusEnumLocs,
	...spCEVoucherBatchDetailStatusEnumLocs,
};
